﻿import React from 'react';

class TextArea extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const useTags = this.props.textArea
        return (
            <div className="stack" dangerouslySetInnerHTML={{ __html: useTags }} />
        )
    }
}

export default TextArea;